export const CURRENT_DOMAIN = '<currentdomain>';
